import { CheckOutlined } from '@ant-design/icons';
import React, { FC } from 'react';
import { twMerge } from 'tailwind-merge';

import { cellHeight, headerClass } from '@/components/Subscription/PlanTable';

interface Props {
  title?: string;
  className?: string;
  classes?: {
    childDivClass?: string;
    pClass?: string;
  };
  style?: React.CSSProperties;
  icon?: boolean;
}

const Cell: FC<Props> = ({ title, className, classes, style, icon }) => {
  return (
    <div className={className} style={{ height: cellHeight, ...style }}>
      <div
        className={twMerge(
          'w-full h-full flex items-center',
          classes?.childDivClass,
        )}
      >
        {icon ? (
          <CheckOutlined className='w-[22px] h-[22px] text-success-400' />
        ) : (
          <></>
        )}
        {title ? (
          <p className={twMerge(`${headerClass}`, classes?.pClass)}>{title}</p>
        ) : (
          <></>
        )}
      </div>
    </div>
  );
};

export default Cell;
